import { render, staticRenderFns } from "./addMatchByBatch.vue?vue&type=template&id=2a4a395c&scoped=true&lang=pug&"
import script from "./addMatchByBatch.vue?vue&type=script&lang=js&"
export * from "./addMatchByBatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4a395c",
  null
  
)

export default component.exports